export default {
    400: 'pages.registration.error.account.not.found',
    403: 'pages.registration.error.account.verification.blocked',
    409: 'pages.registration.error.account.already.exists',
    422: 'pages.registration.error.account.verification.failed',
    453: 'pages.registration.error.account.blocked',
    CodeMismatchException: 'pages.registration.error.verification.code.mismatch',
    LimitExceededException: 'pages.registration.error.too.many.failed.attempts',
    TooManyFailedAttemptsException: 'pages.registration.error.too.many.failed.attempts',
    UsernameExistsException: 'pages.registration.error.username.exists',
};
